import { schemas } from "@card-data/generated/api.client";

import { CreditCardInput } from "../types";

export const FIRST_CARDS: Array<CreditCardInput> = [
  {
    cardId: "73015adf7b2ca52331e05203c4ad5462",
    name: "LATAM Airlines",
    issuer: schemas.IssuersEnum.enum.FIRST,
    network: schemas.NetworksEnum.enum.MASTERCARD,
    currency: schemas.CurrenciesEnum.enum.LATAM,
    isBusiness: false,
    annualFee: 0,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://latampass.latam.com/en_us/earn-miles/latam-airlines-credit-cards",
    imageUrl: "/images/first/latam-airlines.svg",
    credits: [],
    offers: [
      {
        amount: [{ amount: 15_000 }],
        spend: 1000,
        days: 90,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 25_000 }],
        spend: 5000,
        days: 90,
        credits: [],
      },
    ],
  },
  {
    cardId: "7e578b54e8976a7b9027124c56b2377f",
    name: "LATAM Airlines World Elite",
    issuer: schemas.IssuersEnum.enum.FIRST,
    network: schemas.NetworksEnum.enum.MASTERCARD,
    currency: schemas.CurrenciesEnum.enum.LATAM,
    isBusiness: false,
    annualFee: 99,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://latampass.latam.com/en_us/earn-miles/latam-airlines-credit-cards",
    imageUrl: "/images/first/latam-airlines-world-elite.webp",
    credits: [],
    offers: [
      {
        amount: [{ amount: 40_000 }],
        spend: 3500,
        days: 90,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 60_000 }],
        spend: 3500,
        days: 90,
        credits: [],
      },
    ],
  },
  {
    cardId: "684de802ca5bf73c791a752537da84c5",
    name: "Cardless Qatar Signature",
    issuer: schemas.IssuersEnum.enum.FIRST,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.AVIOS,
    isBusiness: false,
    annualFee: 99,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://qatarairways.cardless.com/compare",
    imageUrl: "/images/first/cardless-qatar-signature.jpg",
    credits: [],
    offers: [
      {
        amount: [{ amount: 40_000 }],
        spend: 3000,
        days: 90,
        credits: [],
        details: "20k after any purchase, 20k after spend requirement.",
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 60_000 }],
        spend: 3500,
        days: 90,
        credits: [],
        details: "20k after any purchase, 40k after spend requirement.",
        expiration: "2025-03-31",
      },
    ],
  },
  {
    cardId: "ea277f6af8a60065a83e5f16569dcce8",
    name: "Cardless Qatar Infinite",
    issuer: schemas.IssuersEnum.enum.FIRST,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.AVIOS,
    isBusiness: false,
    annualFee: 499,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://qatarairways.cardless.com/compare",
    imageUrl: "/images/first/cardless-qatar-infinite.jpg",
    credits: [],
    offers: [
      {
        amount: [{ amount: 50_000 }],
        spend: 5000,
        days: 90,
        credits: [],
        details: "25k after any purchase, 25k after spend requirement.",
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 85_000 }],
        spend: 6000,
        days: 90,
        credits: [],
        details: "25k after any purchase, 60k after spend requirement.",
        expiration: "2025-03-31",
      },
    ],
  },
  {
    cardId: "1babfb0011a010a6149965531021ad2e",
    name: "Avianca LifeMiles",
    issuer: schemas.IssuersEnum.enum.FIRST,
    network: schemas.NetworksEnum.enum.AMERICAN_EXPRESS,
    currency: schemas.CurrenciesEnum.enum.AVIANCA,
    isBusiness: false,
    annualFee: 99,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://www.lifemiles.com/discover/landing-page/avianca-lifemiles-creditcard",
    imageUrl: "/images/first/avianca-lifemiles.webp",
    credits: [],
    offers: [
      {
        amount: [{ amount: 40_000 }],
        spend: 4500,
        days: 90,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 50_000 }],
        spend: 4500,
        days: 90,
        credits: [],
      },
    ],
  },
  {
    cardId: "0bcc80cc6922e7c7d89e9c9b2efcd9e1",
    name: "Avianca LifeMiles Elite",
    issuer: schemas.IssuersEnum.enum.FIRST,
    network: schemas.NetworksEnum.enum.AMERICAN_EXPRESS,
    currency: schemas.CurrenciesEnum.enum.AVIANCA,
    isBusiness: false,
    annualFee: 250,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://www.lifemiles.com/discover/landing-page/avianca-lifemiles-creditcard",
    imageUrl: "/images/first/avianca-lifemiles-elite.webp",
    credits: [],
    offers: [
      {
        amount: [{ amount: 60_000 }],
        spend: 4500,
        days: 90,
        credits: [],
        details: "Extra 40k on 25k spend in 1yr.",
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 80_000 }],
        spend: 4500,
        days: 90,
        credits: [],
        details: "Extra 40k on 25k spend in 1yr.",
      },
    ],
  },
  {
    cardId: "0b3a9849575c68ce5cbf31aad08f015e",
    name: "ANA Card USA Plus",
    issuer: schemas.IssuersEnum.enum.FIRST,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.ANA,
    isBusiness: true,
    annualFee: 85,
    isAnnualFeeWaived: true,
    universalCashbackPercent: 1,
    url: "https://www.anacardusa.com/en/",
    imageUrl: "/images/first/ana-card-usa.png",
    credits: [],
    offers: [
      {
        amount: [{ amount: 5_000 }],
        spend: 0.01,
        days: 90,
        credits: [],
        details: "5k after any purchase.",
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 10_000 }],
        spend: 3000,
        days: 90,
        credits: [],
      },
    ],
  },
];
